import React from 'react';
import TextField from 'modules/views/shared/TextField';
import Select from 'modules/views/shared/Select';
import SkippableFieldIndicator from 'modules/views/shared/SkippableFieldIndicator';
import { FieldType, IField } from '../types';
import Chips from 'modules/views/shared/Chips';

interface IFieldWrapperProps {
  field: IField;
  index: number;
  value: string | boolean | null | string[] | Array<{ isSaved: boolean; OtherText: string }>;
  error?: string;
  disabled?: boolean;
}

const FieldWrapper: React.FC<IFieldWrapperProps> = ({ field, index, value, error, disabled }) => {
  if (field.type === FieldType.Picker) {
    return (
      <div>
        <Select
          options={field.mappedOptions || []}
          onChange={field.onChange || (() => {})}
          selectedValue={field.selectedOption}
          disabled={disabled}
          inputLabel={field.name}
          required={field.isRequired}
          error={error}
          addOption={field.addOption}
          testId={field.testId}
        />
        <SkippableFieldIndicator show={field.showSkippableIndicator || false} />
      </div>
    );
  } else if (field.type === FieldType.Chips) {
    return (
      <div>
        <Chips
          chips={field.mappedOptions || []}
          selectedChips={field.selectedChips || []}
          extraChips={field.extraChips || []}
          onChange={disabled ? undefined : field.onChange || (() => {})}
          onExtraChipRemove={field.onExtraChipRemove || (() => {})}
          error={error}
          disabled={disabled}
          testId={field.testId}
        />
        <SkippableFieldIndicator show={field.showSkippableIndicator || false} />
      </div>
    );
  } else if (field.type === FieldType.Text) {
    return (
      <div>
        <TextField
          label={field.name}
          autoFocus={index === 0}
          name={field.id}
          required={field.isRequired}
          value={value as string}
          error={error}
          disabled={disabled}
          onChange={e => field.onChange?.(e.target.value)}
        />
        <SkippableFieldIndicator show={field.showSkippableIndicator || false} />
      </div>
    );
  }

  return null;
};

export default FieldWrapper;
